import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { IoMdArrowDropdown } from "react-icons/io";
import { CgMenu, CgCloseR } from "react-icons/cg";
import logoimage from "../assets/LogoBlack.png";

// Styled components
const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.background};

  @media (max-width: 1000px) {
    .menuIcon {
      display: flex;
      cursor: pointer;
    }
  }
`;

const NavbarList = styled.ul`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 1000px) {
    display: none;
  }
`;

const NavbarItem = styled.li`
  list-style: none;
`;

const NavbarLink = styled(NavLink)`
  display: inline-block;
  text-decoration: none;
  font-size: 26px;
  font-weight: 600;
  font-weight: bold;
  font-family: "Calistoga";

  color: ${({ theme }) => theme.colors.black};
  letter-spacing: 1px;
  position: relative;
  transition: color 0.3s ease-in-out;
  position: relative;

  &:hover,
  &:active,
  &:focus,
  &.active {
    /* Active state ka color bhi change hoga */
    color: #00eeff;
  }

  &::before {
    content: "";
    width: 100%;
    height: 6px;
    /* border-radius: 5px; */
    background-color: #00eeff;
    position: absolute;
    left: 0;
    bottom: -10px;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before,
  &:active::before,
  &:focus::before {
    transform: scaleX(1);
    transform-origin: left;
  }
`;
const NavbarLink5 = styled(NavLink)`
  display: inline-block;
  text-decoration: none;
  color: white;
  background-color: #00eeff;
  font-size: 26px;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 10px;
  /* color: ${({ theme }) => theme.colors.black}; */
  font-family: "Calistoga";
  transition: color 0.3s linear;
  position: relative;

  &:hover,
  &:active,
  &:focus {
    color: ${({ theme }) => theme.colors.black};
  }

  &::before {
    content: "";
    width: 100%;
    height: 2px;
    /* background-color: #00eeff; */
    position: absolute;
    left: 0;
    bottom: -5px;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before,
  &:active::before,
  &:focus::before {
    transform: scaleX(1);
    transform-origin: left;
  }
`;
const NavbarLink1 = styled(NavLink)`
  display: inline-block;
  text-decoration: none;
  /* margin-left: 20px; */
  /* background-color: red; */
  padding-left: 20px;
  line-height: 40px;
  font-size: 13px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
  text-transform: uppercase;
  transition: color 0.3s linear;
  position: relative;

  &:hover,
  &:active,
  &:focus {
    color: ${({ theme }) => theme.colors.black};
  }

  &::before {
    content: "";
    width: 100%;
    height: 2px;
    background-color: #000000;
    position: absolute;
    left: 0;
    bottom: -5px;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before,
  &:active::before,
  &:focus::before {
    transform: scaleX(1);
    transform-origin: left;
  }
`;

const DropdownContainer = styled.div`
  position: relative;
`;

const DropdownToggle = styled.button`
  cursor: pointer;
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: transparent;
  border: none;
  font-weight: bold;
  font-size: 13px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.darkblack};
`;

const DropdownContent = styled.div`
  display: none;
  position: absolute;
  background-color: #f3efef;

  min-width: 250px;
  z-index: 1;

  ${DropdownContainer}:hover & {
    display: block;
  }
`;

const ListColor = styled(NavLink)`
  margin: 10px;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  padding: 10px;
  font-size: 15px;
  color: black;
  border-radius: 5px;
  position: relative;

  &:hover,
  &:active {
    color: #141414;
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 2px;
    width: 0;
    background-color: black;
    transition: width 0.4s ease-in-out;
  }

  &:hover::after {
    width: 100%;
  }
`;
const ListColor1 = styled(NavLink)`
  margin: 10px;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  padding: 10px;
  font-size: 15px;
  color: black;
  line-height: 5px;
  border-radius: 3px;
  position: relative;
  @media screen and (max-width: 600px) {
    text-align: center;
    justify-content: center;
    align-items: center;
  }
  &:hover,
  &:active {
    color: #141414;
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 2px;
    width: 0;
    background-color: black;
    transition: width 0.4s ease-in-out;
  }

  &:hover::after {
    width: 100%;
  }
`;

// const SideNav = styled.div`
//   height: 100%;
//   width: ${({ isOpen }) => (isOpen ? "70%" : "0")};
//   position: fixed;
//   z-index: 1000;
//   top: 0;
//   left: 0;
//   background-color: #ffffff;
//   overflow-x: hidden;
//   transition: 0.3s;
//   display: none; /* Hide initially */

//   @media screen and (max-width: 1000px) {
//     display: flex; /* Show for screens smaller than 1000px */
//     flex-direction: column;
//     padding-top: 130px;
//     width: ${({ isOpen }) =>
//       isOpen ? "80%" : "0"}; /* 80% width for screens smaller than 1000px */
//   }

//   @media screen and (max-width: 600px) {
//     width: ${({ isOpen }) =>
//       isOpen ? "100%" : "0"}; /* 100% width for screens smaller than 600px */
//     height: 100%;
//     align-items: center;
//     justify-content: center;
//     background-color: red;
//     z-index: 3000;
//     font-size: 20px;
//   }
// `;

const SideNav = styled.div`
  height: 100vh;
  width: ${({ isOpen }) => (isOpen ? "70%" : "0")};
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  background: linear-gradient(to bottom, #ffffff, #a7a7f8, #67c2ec);
  overflow: hidden !important;
  transition: width 0.3s;
  display: none; /* Hide initially */
  touch-action: none; /* Prevent scroll gestures on mobile */

  @media screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    padding-top: 130px;
    width: ${({ isOpen }) => (isOpen ? "80%" : "0")};
  }

  @media screen and (max-width: 600px) {
    width: ${({ isOpen }) => (isOpen ? "100%" : "0")};
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
`;


const Backdrop = styled.div`
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 500; /* Slightly less than the SideNav's z-index */
`;

const SideNavCloseIcon = styled(CgCloseR)`
  position: absolute;
  top: 15px;
  right: 20px;
  color: #000000;
  cursor: pointer;
  font-size: 30px;

  @media (max-width: 1000px) {
    top: 35px;
    right: 55px;
  }
`;

const MenuIcon = styled(CgMenu)`
  display: none;

  @media (max-width: 1000px) {
    display: block;
    font-size: 30px;
    color: ${({ theme }) => theme.colors.black};
  }
`;

const Logo1 = styled.img`
  position: absolute;
  top: 15px;
  left: 20px;
  width: 120px;

  @media (max-width: 600px) {
    width: 80px;
    height: 60px;
    top: 20px;
    left: 30px;
  }
`;

// New styled component for the dropdown inside SideNav
const SideNavDropdownContainer1 = styled(DropdownContainer)`
  margin-left: 20px;
  @media screen and (max-width: 600px) {
    text-align: center;
    justify-content: center;
    align-items: center;
  }
  /* background-color: red; */
`;

const SideNavDropdownToggle1 = styled(DropdownToggle)`
  /* background-color: blue; */
`;

const SideNavDropdownContent1 = styled(DropdownContent)`
  background-color: #ffffff;
  position: relative;
`;

// Dropdown component
const Dropdown = ({ title, items, onItemClick }) => {
  return (
    <DropdownContainer>
      <DropdownToggle>
        {title}{" "}
        <IoMdArrowDropdown style={{ color: "black", marginLeft: "5px" }} />
      </DropdownToggle>
      <DropdownContent>
        {items.map((item, index) => (
          <ListColor key={index} to={item.link} onClick={onItemClick}>
            {item.text}
          </ListColor>
        ))}
      </DropdownContent>
    </DropdownContainer>
  );
};

// Dropdown for SideNav
const SideNavDropdown = ({ title, items, onItemClick }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <SideNavDropdownContainer1>
      <SideNavDropdownToggle1 onClick={toggleDropdown}>
        {title}{" "}
        <IoMdArrowDropdown style={{ color: "black", marginLeft: "5px" }} />
      </SideNavDropdownToggle1>
      {isDropdownOpen && (
        <SideNavDropdownContent1>
          {items.map((item, index) => (
            <ListColor1
              key={index}
              to={item.link}
              onClick={() => {
                onItemClick();
                setIsDropdownOpen(false);
              }}
            >
              {item.text}
            </ListColor1>
          ))}
        </SideNavDropdownContent1>
      )}
    </SideNavDropdownContainer1>
  );
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const services = [
    { text: "Mobile App Development", link: "/MobileAppDev" },
    { text: "Game Development", link: "/GameDevelopment" },
    { text: "Web Development", link: "/WebDevelopment" },
    { text: "2D-3D Game Art", link: "/GameArt" },
    { text: "UI / UX", link: "/UiUx" },
    { text: "AR / VR", link: "/arvr" },
  ];

  const toggleSideNav = () => {
    setIsOpen(!isOpen);
  };

  // Handle item click to close the side nav
  const handleItemClick = () => {
    setIsOpen(false);
  };

  return (
    <Nav>
      <MenuIcon className="menuIcon" onClick={toggleSideNav} />

      <NavbarList>
        <NavbarItem>
          <NavbarLink to="/" onClick={handleItemClick}>
            Home
          </NavbarLink>
        </NavbarItem>
        <NavbarItem>
          <NavbarLink to="/about" onClick={handleItemClick}>
            About Us
          </NavbarLink>
        </NavbarItem>
        <NavbarItem>
          <NavbarLink to="/hiredeveloper" onClick={handleItemClick}>
            Our Service
          </NavbarLink>
        </NavbarItem>
        <NavbarItem>
          <NavbarLink to="/portfolio" onClick={handleItemClick}>
            Portfolio
          </NavbarLink>
        </NavbarItem>
        {/* <NavbarItem><Dropdown title="Our Services" items={services} onItemClick={handleItemClick} /></NavbarItem> */}
        <NavbarItem>
          <NavbarLink5 to="/ContactUs" onClick={handleItemClick}>
            Get a Quate
          </NavbarLink5>
        </NavbarItem>
      </NavbarList>

      <Backdrop isOpen={isOpen} onClick={toggleSideNav} />

      <SideNav isOpen={isOpen}>
        <Logo1 src={logoimage} alt="Logo" />
        <SideNavCloseIcon onClick={toggleSideNav} />
        <NavbarItem>
          <NavbarLink1 to="/" onClick={handleItemClick}>
            Home
          </NavbarLink1>
        </NavbarItem>
        <NavbarItem>
          <NavbarLink1 to="/portfolio" onClick={handleItemClick}>
            Portfolio
          </NavbarLink1>
        </NavbarItem>
        <NavbarItem>
          <NavbarLink1 to="/about" onClick={handleItemClick}>
            About Us
          </NavbarLink1>
        </NavbarItem>
        {/* <NavbarItem><SideNavDropdown title="Our Services" items={services} onItemClick={handleItemClick} /></NavbarItem> */}
        <NavbarItem>
          <NavbarLink1 to="/hiredeveloper" onClick={handleItemClick}>
            Hire Developer
          </NavbarLink1>
        </NavbarItem>
        <NavbarItem>
          <NavbarLink1 to="/ContactUs" onClick={handleItemClick}>
            Contact Us
          </NavbarLink1>
        </NavbarItem>
      </SideNav>
    </Nav>
  );
};

export default Navbar;
